<template>
  <div class="kalkulator">
    <div v-if="step === 1">
      <div class="kalkulator-header">
        <h1 class="display-4 title"><span>Porównywarka cen części</span></h1>
        <p>Pewnie wiele razy zastanawiałeś się nad tym, czy ceny części jakie otrzymujesz w hurtowni są dobre, czy może inni właściciele warsztatów kupują taniej?</p>
        <p>Teraz w naszym sondażu możesz dokonać łatwego porównania. Wystarczy, że wykonasz trzy poniższe kroki.</p>
      </div>
      <div class="step">
        <span class="number">1</span>
        <p>
          Sprawdź w katalogu hurtowni u której się zaopatrujesz cenę wymienionych poniżej produktów i wpisz ją w okienko (aby się nie pomylić skopiuj numer części).
        </p>
        <ul>
          <li>
            <div class="table-header row">
              <div class="col-lg-1">Producent</div>
              <div class="col-lg-3">Numer części</div>
              <div class="col-lg-5">Opis</div>
              <div class="col">Twoja cena zakupu</div>
            </div>
          </li>
          <li v-for="(item, index) in questions" v-bind:key="index">
            <KalkulatorInput
            v-bind:price="item.average_price"
            v-bind:title="item.title"
            v-bind:company="item.company"
            v-bind:partsKey="item.partsKey"
            v-bind:between="item.between"
            v-bind:id="item.id"
            v-bind:index="index"
            @change="change"
            />
          </li>
        </ul>
        <div v-if="showMiniumLength" class="alert alert-warning" role="alert">
          Odpowiedz na wszystkie pytania!
        </div>
      </div>
      <div class="step select">
        <span class="number">2</span>
        <div class="form-group">
          <select class="form-control" v-model="businessSize">
            <option value="" selected disabled>Zaznacz jakiej wielkości jest Twój warsztat</option>
            <option>mały warsztat</option>
            <option>średni warsztat</option>
            <option>duży warsztat</option>
          </select>
        </div>
      </div>
      <div class="step select">
        <span class="number">3</span>
        <div class="form-group">
          <select class="form-control" v-model="voivodeship">
            <option value="" selected disabled>Wybierz województwo w którym działa Twój warsztat</option>
            <option>dolnośląskie</option>
            <option>kujawsko-pomorskie</option>
            <option>lubelskie</option>
            <option>lubuskie</option>
            <option>łódzkie</option>
            <option>małopolskie</option>
            <option>mazowieckie</option>
            <option>opolskie</option>
            <option>podkarpackie</option>
            <option>podlaskie</option>
            <option>pomorskie</option>
            <option>śląskie</option>
            <option>świętokrzyskie</option>
            <option>warmińsko-mazurskie</option>
            <option>wielkopolskie</option>
            <option>zachodniopomorskie</option>
          </select>
        </div>
      </div>
      <div v-if="showSelectOptions" class="alert alert-warning" role="alert">
        Odpowiedz na wszystkie pytania!
      </div>
      <div class="text-center">
        <button v-on:click="goToSummary" class="btn btn-primary btn-lg">Porównaj ceny</button>
      </div>
    </div>
    <div v-else-if="step == 2">
      <div class="kalkulator-header">
        <h1 class="display-4 title"><span>Twoje wyniki</span></h1>
      </div>
      <Summary
      v-bind:questions="questions"
      v-bind:response="response"
      v-bind:apiUrl="apiUrl"
      />
    </div>
  </div>
</template>

<script>
import KalkulatorInput from './KalkulatorInput'
import Summary from './Summary'
import axios from 'axios'

export default {
  name: 'HelloWorld',
  data: function () {
    return {
      // apiUrl: 'http://motofocus.dev/',
      apiUrl: 'https://kalkulatorapi.motofocus.pl/',
      step: 1,
      responseMinimum: 5,
      showMiniumLength: false,
      showSelectOptions: false,
      questions: [
        {
          id: 1,
          title: 'Sworzeń wahacza Peugeot 407',
          company: 'SKF',
          partsKey: 'VKD 13500',
          average_price: 0,
          ranges: [
            [80, 129.99],
            [130, 149.99],
            [150, 300]
          ],
          rangesText: [
            'Bardzo niska',
            'Średnia',
            'Wysoka'
          ],
          between: [80, 300]
        },
        {
          id: 2,
          title: 'Zestaw sprzęgła do Ford Focus 1.6 16V',
          company: 'LUK',
          partsKey: '622241433',
          average_price: 0,
          ranges: [
            [272, 429.99],
            [430, 479.99],
            [480, 700]
          ],
          rangesText: [
            'Bardzo niska',
            'Średnia',
            'Wysoka'
          ],
          between: [272, 700]
        },
        {
          id: 3,
          title: 'Klocki hamulcowe BMW serii 7',
          company: 'ATE',
          partsKey: '13.0460-7079.2',
          average_price: 0,
          ranges: [
            [84, 125.99],
            [136, 159.99],
            [160, 300]
          ],
          rangesText: [
            'Bardzo niska',
            'Średnia',
            'Wysoka'
          ],
          between: [84, 300]
        },
        {
          id: 4,
          title: 'Pasek klinowy wielorowkowy BMW E46',
          company: 'Conti',
          partsKey: '6pk2080',
          average_price: 0,
          ranges: [
            [20, 47.99],
            [48, 59.99],
            [60, 130]
          ],
          rangesText: [
            'Bardzo niska',
            'Średnia',
            'Wysoka'
          ],
          between: [20, 130]
        },
        {
          id: 5,
          title: 'Filtr paliwa Toyota/Honda',
          company: 'Filtron',
          partsKey: 'PP855/1',
          average_price: 0,
          ranges: [
            [26.6, 59.99],
            [60, 64.99],
            [65, 150]
          ],
          rangesText: [
            'Bardzo niska',
            'Średnia',
            'Wysoka'
          ],
          between: [26.6, 150]
        }
      ],
      response: [],
      voivodeship: '',
      businessSize: ''
    }
  },
  created: function () {
  },
  methods: {
    change: function (id, value, position) {
      console.log(value)
      if (value != null) {
        let status = false
        this.response.forEach(function (element, index) {
          if (id === element.id) {
            console.log(id + ' ' + element.id)
            this.response[position].value = value
            status = true
          }
        }, this)
        if (!status) {
          this.response[position] = {id: id, value: value}
        }
      } else {
        this.response.forEach(function (element, index) {
          if (id === element.id) {
            console.log(id + ' ' + element.id)
            this.response.splice(position, 1)
          }
        }, this)
      }
    },
    goToSummary: function () {
      if (this.response.length < this.responseMinimum) {
        this.showMiniumLength = true
        return
      } else {
        this.showMiniumLength = false
      }

      let status = true
      for (let i = 0; i < this.response.length; i++) {
        if (typeof this.response[i] === 'undefined') {
          status = false
        }
      }
      if (!status) {
        this.showMiniumLength = true
        return
      }
      if (this.voivodeship === '' || this.businessSize === '') {
        this.showSelectOptions = true
        return
      } else {
        this.showSelectOptions = false
      }
      let self = this
      axios.post(this.apiUrl, {response: this.response, voivodeship: this.voivodeship, businessSize: this.businessSize})
        .then(function (response) {
          self.step++
          console.log(response)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  components: {
    KalkulatorInput,
    Summary
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/variables';
@import './../assets/mixin';

$primary: #0069d9;
ul{
  list-style: none;
  margin:0px;
  padding:0px;
  li{
    list-style: none;
  }
}
.star{
  font-size: 12px;
  opacity: 0.4;
}
.title{
  margin-top: 30px;
  margin-bottom: 30px;
  span{
    display: inline-block;
  }
  @include underPhone(){
    font-size: 40px;
  }
}
.kalkulator-header{
  margin-bottom: 40px;
}
.step{
  position: relative;
  margin-left: 70px;
  background-color: #F2F2F2;
  padding:15px;
  margin-bottom: 15px;
  &.select{
    background: none;
    padding:5px 0px 0px 0px;
    @include underTablet(){
      margin-left: 60px;
      margin-top: 15px;
      .number{
        top:-0px;
        left: -60px;
      }
    }
  }
  .number{
    position: absolute;
    top:0px;
    left: -70px;
    width:50px;
    height: 50px;
    line-height: 47px;
    text-align: center;
    background-color: $primary;
    color: white;
    font-size: 20px;
    border-radius: 25px;
    @include underTablet(){
      left: -10px;
      top:-35px;
    }
  }
  @include underTablet(){
    margin-left: 0px;
    margin-top:50px;
    padding-bottom: 0px;
  }
}
.table-header{
  margin-bottom: 15px;
  font-weight: 700;
  background-color: darken(#F2F2F2,10);
  font-size: 10px;
  div{
    padding-top:10px;
    padding-bottom:10px;
  }
  @include underTablet(){
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Kalkulator.vue